/**
 * Staff role ids, mirroring the API's roles_module table. The role of the signed-in user is held
 * in the admin_role cookie as a string, which is why the ids are declared as strings here.
 */
export const ADMIN_ROLE = '1';
export const PICKER_ROLE = '8';
export const PRODUCT_ADMINISTRATOR_ROLE = '9';
export const DISPATCH_OPERATOR_ROLE = '10';

/**
 * Roles managed in the Admin Users section, mirroring Role::getAdminPanelRoles() on the API.
 */
export const ASSIGNABLE_ADMIN_ROLES = [
  { id: +ADMIN_ROLE, label: 'Admin' },
  { id: +PICKER_ROLE, label: 'Picker' },
  { id: +PRODUCT_ADMINISTRATOR_ROLE, label: 'Product Administrator' },
  { id: +DISPATCH_OPERATOR_ROLE, label: 'Dispatch Operator' },
];

interface IRoleSection {
  /** Name of the only _nav.ts entry this role may use. */
  navName: string;
  landingUrl: string;
}

/**
 * Roles limited to a single sidebar section. Their sidebar is reduced to that section plus Log Out,
 * and they land on it after signing in instead of the dashboard.
 */
export const RESTRICTED_ROLE_SECTIONS: { [role: string]: IRoleSection } = {
  [PRODUCT_ADMINISTRATOR_ROLE]: { navName: 'Products', landingUrl: '/products/all' },
  [DISPATCH_OPERATOR_ROLE]: { navName: 'Orders', landingUrl: '/orders/all' },
};
